import {
  PRACTICE_LEDGER_DATE_RANGE_PRESET,
  type PracticeLedgerDateRange,
  type PracticeLedgerDateRangeSelection,
} from "@/billing/types/practice-ledger";

import { getPracticeLedgerDateRange } from "./practice-ledger-date-range";

/**
 * The window a Show: selection covers on `now`'s calendar day.
 *
 * @param selection The stored Show: selection.
 * @param now The moment to resolve a named preset against.
 * @returns The named preset's window for `now`, or the custom range unchanged.
 */
export function resolvePracticeLedgerSelectionDateRange(
  selection: PracticeLedgerDateRangeSelection,
  now = new Date(),
): PracticeLedgerDateRange {
  if (selection.preset === PRACTICE_LEDGER_DATE_RANGE_PRESET.Custom) return selection.dateRange;
  return getPracticeLedgerDateRange(selection.preset, now);
}
